import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicCheckbox from "./BasicCheckbox";

const CheckboxPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Checkbox"}
        description={
          "Checkboxes allow the user to select one or more items from a set."
        }
      />
      <Divider light />

      <BasicCheckbox />
    </Paper>
  );
};

export default CheckboxPage;
